import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import BaseController from '../../../BaseController';
import { FragmentNames, HealthHistoryAllergiesListAliases } from '../../../../codegen';
import { ApplicationRoute } from '../../../../constants/routes';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { HealthHistoryListContext } from '../../service/health-history-list-service';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';
import { Inject } from '@odinjs/odin';

@Controller ({ component: HealthHistoryAllergiesListAliases.LAYOUT_HEALTH_HISTORY_ALLERGIES_LIST, fragment: FragmentNames.HEALTH_HISTORY_ALLERGIES_LIST })
export default class HealthHistoryAllergiesListController extends BaseController {

  @Inject(HealthHistoryAllergiesListAliases.PANEL_HEALTH_HISTORY_ALLERGIES)
  private panelHealthHistoryAllergiesAPI!: PanelAPI;

  @OnMount(HealthHistoryAllergiesListAliases.LAYOUT_HEALTH_HISTORY_ALLERGIES_LIST)
  handleMountLayoutAllergiesList(): void {
    const allowInfo = InformationBarUtils.allowInfo && HealthHistoryListContext.isAllowEdit;
    this.panelHealthHistoryAllergiesAPI.setVisible(allowInfo);
  }

  @OnClick({ target: HealthHistoryAllergiesListAliases.BUTTON_ADD_HEALTH_HISTORY_ALLERGIES })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.HEALTH_HISTORY_ALLERGIES_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: HealthHistoryAllergiesListAliases.DECK_HEALTH_HISTORY_ALLERGIES })
  handleOnClickCard(event: ClickEvent): void {
    const { idHealthHistory, releaseDate } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && HealthHistoryListContext.isAllowEdit;
    const accessViewer = releaseDate || !allowInfo;
    const route = accessViewer ? ApplicationRoute.HEALTH_HISTORY_ALLERGIES_VIEWER : ApplicationRoute.HEALTH_HISTORY_ALLERGIES_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idHealthHistory,
      patientId,
    });
  }
}
